<template>
  <section class="day-part-filter">
    <h3 class="my-4 font-bold">Type dienst</h3>
    <option-grid v-model="value" multi
                 :options="typeOptions"/>
  </section>
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import OptionGrid from '../OptionGrid.vue';

const emit = defineEmits(['update:modelValue']);
const props = defineProps<{
  modelValue: any,
}>();

const value = computed({
  get() {
    return props.modelValue;
  },
  set(to) {
    emit('update:modelValue', to);
  },
});

const typeOptions = [
  { name: 'Ochtend', value: 1 },
  { name: 'Middag', value: 2 },
  { name: 'Avond', value: 3 },
  { name: 'Nacht', value: 4 }];

</script>
